import { render, staticRenderFns } from "./studentAttendance.vue?vue&type=template&id=907985a4"
import script from "./studentAttendance.vue?vue&type=script&lang=js"
export * from "./studentAttendance.vue?vue&type=script&lang=js"
import style0 from "./studentAttendance.vue?vue&type=style&index=0&id=907985a4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports